<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6">
    <path
      d="M9.7.303A1.038 1.038 0 0 0 8.97 0a.998.998 0 0 0-.756.303L5.001 3.506 1.788.303A1.042 1.042 0 0 0 1.058 0h-.01C.768 0 .505.107.304.3-.1.688-.102 1.341.302 1.76l3.961 3.937c.195.194.457.302.72.302.038.002.036 0 .053 0a.991.991 0 0 0 .703-.303L9.7 1.747c.4-.398.4-1.046 0-1.444"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
